import { Box, Flex, Image } from '@chakra-ui/react';

import { FullFooter } from '@/components/Common/Marketing/FullFooter';
import { FullHeader } from '@/components/Common/Marketing/FullHeader';
import { terrain } from '@/utils/fonts';

import HexagonImg from './images/directory-header-bg.png';

export const DirectoryPageContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex bgColor="#EEFCF8" flexDir="column" minHeight="100vh">
      <FullHeader />

      <Flex
        flexDirection="column"
        flexGrow="1"
        justifyContent="flex-start"
        overflow="hidden"
        position="relative"
        py={{ base: '32px', md: '96px' }}
      >
        <Box maxWidth="1280px" mx="auto" paddingX={{ base: '24px', md: '32px' }} width="100%">
          <Box
            as="h1"
            color="teal.500"
            fontFamily={terrain.style.fontFamily}
            fontSize={{ base: '32px', md: '64px' }}
            fontWeight="300"
            letterSpacing="-1.92px"
            lineHeight={1}
          >
            Company Directory
          </Box>

          <Flex
            color="gray.600"
            fontSize={{ base: '14px', md: '18px' }}
            fontWeight="400"
            marginTop={{ base: '16px' }}
          >
            Browse Neuron directory for list of companies and their employees.
          </Flex>
        </Box>

        <Box as="picture" pointerEvents="none" position="absolute" right="0" top="0">
          <Image alt="" ml="auto" mr="0" src={HexagonImg.src} />
        </Box>
      </Flex>

      {children}

      <FullFooter />
    </Flex>
  );
};
